import { PositionSettingsLoaded,PositionSettingAdded,
        PositionSettingUpdated, PositionSettingDeleted, PositionSettingConfigurationLoaded } from "features/positions/longShort.actions";
import { PositionSetting } from "domain/positionSetting";
import PositionSettingConfiguration from "../settings/longshort/positionSettingConfiguration";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
  
  export class PositionReducer extends ReducerBase<PositionSetting[]> {
    constructor() {
      super();
      this.addHandler(PositionSettingsLoaded.EventName, this.handlePositionsLoaded);
      this.addHandler(PositionSettingAdded.EventName, this.handlePositionAdded);
      this.addHandler(PositionSettingUpdated.EventName, this.handlePositionUpdated);
      this.addHandler(PositionSettingDeleted.EventName, this.handlePositionDeleted)
    }
  
    handlePositionsLoaded(
      state: PositionSetting[] = initialState.positionSettings,
      event: PositionSettingsLoaded
    ): PositionSetting[] {
      return event.positionSettings;
    }
  
   
    handlePositionAdded(
      state: PositionSetting[] = initialState.positionSettings,
      event: PositionSettingAdded
    ): PositionSetting[] {
      return [...state, { ...event.position }];
    }
  
    handlePositionUpdated(
      state: PositionSetting[] = initialState.positionSettings,
      event: PositionSettingUpdated
    ): PositionSetting[] {
      return state.map(t => (t.id === event.position.id ? event.position : t));
    }
  
    handlePositionDeleted(
      state: PositionSetting[] = initialState.positionSettings,
      event: PositionSettingDeleted
    ): PositionSetting[] {
      return state.filter(t => (t.id !== event.positionSetting.id));
    }
  
    handleDefault(state: PositionSetting[] = initialState.positionSettings) {
      return state;
    }
  }
  
  export class PositionSettingConfigurationReducer extends ReducerBase<PositionSettingConfiguration> {
    constructor() {
        super();
        this.addHandler(PositionSettingConfigurationLoaded.EventName, this.handlePositionsConfigurationLoaded);
    }

    handlePositionsConfigurationLoaded(
      state: PositionSettingConfiguration = initialState.positionSettingConfiguration,
      event: PositionSettingConfigurationLoaded
    ): PositionSettingConfiguration {
      return event.positionSettingconfiguration;
    }


    handleDefault(state: PositionSettingConfiguration = initialState.positionSettingConfiguration) {
        return state;
    }
}